import { render, staticRenderFns } from "./TvMacroWinEdit.vue?vue&type=template&id=5231bd65&scoped=true&"
import script from "./TvMacroWinEdit.vue?vue&type=script&lang=js&"
export * from "./TvMacroWinEdit.vue?vue&type=script&lang=js&"
import style0 from "./TvMacroWinEdit.vue?vue&type=style&index=0&id=5231bd65&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5231bd65",
  null
  
)

export default component.exports